import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale } from '@ardoq/i18n';

export const getI18nLocaleFromSelectProps = (selectProps: object): I18nLocale =>
  (selectProps as { i18nLocale?: I18nLocale }).i18nLocale ??
  DEFAULT_ARDOQ_I18NLOCALE;
